import "./App.css";
import { Routes, Route, Link } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Hero from "./Components/Hero";
import ChooseCar from "./Components/ChooseCar";
import Footer from "./Components/Footer";
import OurCars from "./Components/OurCars";
import Vehicles from "./Components/Admin/Vehicles";
import RideDetails from "./Components/RideDetails";
import ReserveChooseCar from "./Components/ReserveChooseCar";
import DriverBookings from "./Components/Admin/DriverBooking";
import Bookings from "./Components/Admin/Bookings";
import BookingDetails from "./Components/Admin/BookingDetails";
import AdminNavbar from "./Components/Admin/AdminNavbar";
import Drivers from "./Components/Admin/Drivers";
import { FaPhoneVolume } from "react-icons/fa6";
import MyBookings from "./Components/MyBookings";
import Login from "./Components/Admin/Login";
import TrialLogin from "./Components/Login";
import ProtectedRoute from "./Components/Admin/ProtectedRoute";
import Hero2 from "./Components/Hero2";
import BookingsHistory from "./Components/Admin/BookingsHistory";
import AboutUs from "./Components/AboutUs";
import FAQ from "./Components/FAQ";
import OurCarsPage from "./Components/OurCarsPage";
import { ToastContainer } from "react-toastify";
import TermsOfService from "./Components/Policies/TermsOfService";
import Privacy from "./Components/Policies/Privacy";
import MyBookingDetails from "./Components/MyBookingDetails";
import Contact from "./Components/Contact";
import { IoLogoWhatsapp } from "react-icons/io";
import AddOfflineBooking from "./Components/Admin/AddOfflineBooking";
import OfflineBookings from "./Components/OfflineBookings";

function App() {
  return (
    <div className="App">
      <ToastContainer />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Navbar />
              <Hero />
              <OurCars />
              <Hero2 />
              <FAQ />
              <Footer />
              <a
                href="https://api.whatsapp.com/send/?phone=917576825040&text=Hi+%0A%0AI%E2%80%99d+like+to+enquire+about+a+ride+with+DibruGO+%0A%0ACould+you+please+share+the+availability+and+pricing%3F%0A%0AThank+you+&type=phone_number&app_absent=0"
                target="_blank"
                className="msgdial"
              >
                <IoLogoWhatsapp className="icondial icon me-1" /> Chat
              </a>
              <a href="tel:7576825040" className="speeddial">
                <FaPhoneVolume className="icondial icon me-1" /> Book with a
                Quick Call
              </a>
            </>
          }
        />

        <Route
          path="/book-reliable-taxi-service-in-dibrugarh-with-DibruGo-affordable-airport-transfers-local-rides-and-outstation-trips-with-professional-drivers"
          element={
            <>
              <Navbar />
              <Hero />
              <OurCars />
              <Hero2 />
              <FAQ />
              <Footer />
              <a
                href="https://api.whatsapp.com/send/?phone=917576825040&text=Hi+%0A%0AI%E2%80%99d+like+to+enquire+about+a+ride+with+DibruGO+%0A%0ACould+you+please+share+the+availability+and+pricing%3F%0A%0AThank+you+&type=phone_number&app_absent=0"
                target="_blank"
                className="msgdial"
              >
                <IoLogoWhatsapp className="icondial icon me-1" /> Chat
              </a>
              <a href="tel:7576825040" className="speeddial">
                <FaPhoneVolume className="icondial icon me-1" /> Book with a
                Quick Call
              </a>
            </>
          }
        />

        <Route
          path="/reliable-taxi-service-in-dibrugarh-with-DibruGo-affordable-airport-transfers-local-rides-and-outstation-trips"
          element={
            <>
              <Navbar />
              <AboutUs />
              <Footer />
            </>
          }
        />

        <Route
          path="/about-us-dibrugo"
          element={
            <>
              <Navbar />
              <AboutUs />
              <Footer />
            </>
          }
        />

        <Route
          path="/contact-us-dibrugo"
          element={
            <>
              <Navbar />
              <Contact />
              <Footer />
            </>
          }
        />

        <Route
          path="/our-cars"
          element={
            <>
              <Navbar />
              <OurCarsPage />
              <Footer />
            </>
          }
        />

        <Route
          path="/ride/:location"
          element={
            <>
              <Navbar />
              <ChooseCar />
            </>
          }
        />

        <Route
          path="/my-bookings"
          element={
            <>
              <Navbar />
              <MyBookings />
              {/* <Footer /> */}
            </>
          }
        />

        <Route
          path="/my-bookings-details/:id"
          element={
            <>
              <Navbar />
              <MyBookingDetails />
              {/* <Footer /> */}
            </>
          }
        />

        <Route
          path="/my-ride-details"
          element={
            <>
              <Navbar />
              <RideDetails />
              {/* <Footer /> */}
            </>
          }
        />

        <Route
          path="/o-bookings/:id/:customer_contact"
          element={
            <>
              <Navbar />
              <OfflineBookings />
              <Footer />
            </>
          }
        />

        <Route
          path="/choose-reserve-car"
          element={
            <>
              <Navbar />
              <ReserveChooseCar />
              {/* <Footer /> */}
            </>
          }
        />

        <Route
          path="/our-cars"
          element={
            <>
              <Navbar />
              <OurCars />
              {/* <Footer /> */}
            </>
          }
        />

        <Route
          path="/terms-of-service"
          element={
            <>
              <Navbar />
              <TermsOfService />
              <Footer />
            </>
          }
        />

        <Route
          path="/privacy-policy"
          element={
            <>
              <Navbar />
              <Privacy />
              <Footer />
            </>
          }
        />

        <Route
          path="/login"
          element={
            <>
              <Navbar />
              <TrialLogin />
              <Footer />
            </>
          }
        />

        {/* Admin App start*/}
        <Route
          path="/admin-login"
          element={
            <>
              <Login />
            </>
          }
        />

        <Route
          path="/admin-cars"
          element={
            <>
              <ProtectedRoute>
                <AdminNavbar />
                <Vehicles />
              </ProtectedRoute>
            </>
          }
        />

        <Route
          path="/admin-bookings-history"
          element={
            <>
              <ProtectedRoute>
                <AdminNavbar />
                <BookingsHistory />
              </ProtectedRoute>
            </>
          }
        />

        <Route
          path="/add-offline-booking"
          element={
            <>
              <ProtectedRoute>
                <AdminNavbar />
                <AddOfflineBooking />
              </ProtectedRoute>
            </>
          }
        />

        <Route
          path="/admin-live-bookings"
          element={
            <>
              <ProtectedRoute>
                <AdminNavbar />
                <Bookings />
              </ProtectedRoute>
            </>
          }
        />

        <Route
          path="/admin-live-booking-details/:id"
          element={
            <>
              <ProtectedRoute>
                <AdminNavbar />
                <BookingDetails />
              </ProtectedRoute>
            </>
          }
        />

        <Route
          path="/admin-drivers"
          element={
            <>
              <ProtectedRoute>
                <AdminNavbar />
                <Drivers />
              </ProtectedRoute>
            </>
          }
        />
        {/* Admin App ended*/}

        <Route
          path="/driver-booking/:id"
          element={
            <>
              {/* <AdminNavbar /> */}
              <DriverBookings />
            </>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
